<template>
	<WindowForAlert ref="window" :title="getLanguageStr('manage26', '查看所属系统')" :btn-cancel="false">
		<template slot="btmBtn">
			<a v-if="stage.loc.customer == 'SOLARMAN'" :href="url" class="subBtn dpIB" target="_blank" rel="noopener">{{
				getLanguageStr("manage471", "查看授权操作手册")
			}}</a>
			<button type="button" class="functionBtn" @click="$refs.window.hide()">{{ getLanguageStr("cmd15", "我知道了") }}</button>
		</template>
		<div class="mb2x fsField">
			{{ getLanguageStr("manage470", "该电站已打开授权限制，你需要联系该电站管理者将电站授权给你") }}
		</div>
		<div>{{ getLanguageStr("word204", "电站") }}:{{ stationData.siteName }}</div>
	</WindowForAlert>
</template>

<script>
import { getLanguageStr } from '@/util/language'
import WindowForAlert from '@/components/common/ui/WindowForAlert.vue';
export default {
	name: "WatchSystem",
	props: {},
	components: {WindowForAlert},
	data() {
		return {
			stage,
			stationData: {
				siteName: null,
			},
			url: "",
		};
	},
	methods: {
		getLanguageStr,
		show(data, url) {
			console.log(data,'dd')
			this.stationData = data;
			// this.url = url;
			console.log(this.$refs.Window,'w')
			this.$refs.window.show();
		},
	},
	created() {},
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/view/device/device/part/WatchSystem.vue